// API
const headers = {
  "Content-Type": "application/graphql",
  "X-Shopify-Storefront-Access-Token": "eb01531c2dbd30a0e8b5162ff6a625e4",
};

// Queries
const PRODUCT_QUERY = `
  availableForSale
  id
  title
  description(truncateAt: 80)
  handle
  tags
  productType
  options {
    name,
    values
  }
  featuredImage {
    src
    height
    width
  }
  images(first: 20) {
    edges {
      node {
        altText
        url
      }
    }
  }
  priceRange {
    maxVariantPrice {
      amount
    }
    minVariantPrice {
      amount
    }
  }
  variants(first: 250) {
    edges {
      node {
        id
        availableForSale
        compareAtPrice {
          amount
        }
        price {
          amount
        }
        title
        selectedOptions {
          value
          name
        }
      }
    }
  }
  vendor
  metafield(key: "location", namespace: "information") {
    value
  }
`;

// Product Mutation
function transformGraphqlProduct(productNode) {
  if (!productNode) {
    return null;
  }

  const variants = productNode.variants.edges.map(({ node }) => {
    return {
      id: parseInt(node.id.replace("gid://shopify/ProductVariant/", "")),
      available: node.availableForSale,
      compare_at_price: node.compareAtPrice?.amount || null,
      options: node.selectedOptions.map((option) => option.value),
      option1: node.selectedOptions[0].value,
      price: node.price?.amount || null,
      title: node.selectedOptions[0].value,
    };
  });

  const options = productNode.options.map((option) => option.name);
  const options_with_values = productNode.options.map((option) => {
    return {
      name: option.name,
      position: productNode.options.indexOf(option) + 1,
      title: option.values,
    };
  });

  return {
    objectType: "product",
    available: productNode.availableForSale,
    handle: productNode.handle,
    url: `/products/${productNode.handle}`,
    id: parseInt(productNode.id.replace("gid://shopify/Product/", "")),
    tags: productNode.tags.map((tag) => tag.toLowerCase()),
    productType: productNode.productType,
    title: productNode.title,
    description: productNode.description,
    variants,
    price: productNode.priceRange.minVariantPrice.amount.replace(".", ","),
    compare_at_price: productNode.variants.edges[0].node.compareAtPrice.amount === productNode.variants.edges[0].node.price.amount ? "" : productNode.variants.edges[0].node.compareAtPrice.amount,
    // compare_at_price: productNode.variants.edges[0].node.compareAtPrice?.amount.replace(".", ",") || null,

    featured_image: productNode.featuredImage,
    images: productNode.images.edges.map((image) => image.node.url),
    metafield: productNode.metafield?.value,
    has_only_default_variant: productNode.options[0].values[0] === "Default Title",
    options,
    vendor: productNode.vendor,
    ...(productNode.options[0] && { option1: productNode.options[0].name }),
    ...(productNode.options[1] && { option2: productNode.options[1].name }),
    ...(productNode.options[2] && { option3: productNode.options[2].name }),
    options_with_values,
  };
}

// Color Swatch Change Function
function colorSwatchsChange(productId, clickedElement) {
  try {
    // Keep the user on the listing page: don't follow a wrapping link or trigger card navigation
    const clickEvent = window.event;
    if (clickEvent && clickEvent.type === "click") {
      clickEvent.preventDefault();
      clickEvent.stopPropagation();
    }

    // Get the swatch element - could be passed directly or need to find it
    const swatchElement = clickedElement?.closest?.(".color-swatch") || clickedElement || null;

    if (!swatchElement) {
      console.log("Error: Swatch element not found");
      return;
    }
    const productCard = swatchElement?.parentNode?.parentNode?.parentNode.querySelector(".product-card");

    // Remove 'active' class from all sibling color-swatches
    const colorSwatchContainer = swatchElement.closest(".color-swatches");
    if (colorSwatchContainer) {
      const swatches = colorSwatchContainer.querySelectorAll(".color-swatch");
      swatches.forEach((el) => el.classList.remove("active"));
    }
    // Add 'active' class to the clicked color-swatch
    swatchElement.classList.add("active");

    // Get the variant image URL, variant ID, and color value from data attributes
    const variantImageUrl = swatchElement.getAttribute("data-variant-image");
    const variantId = swatchElement.getAttribute("data-variant-id");
    const colorValue = swatchElement.getAttribute("data-color-value");

    if (!variantImageUrl) {
      console.log("Error: No variant image URL found on swatch element");
      return;
    }

    if (!variantId) {
      console.log("Error: No variant ID found on swatch element");

      return;
    }

    // Find the product card
    const card = document.querySelector(`div[data-product-id="${productId}"], product-card[data-product-id="${productId}"]`);
    const resourceCard = swatchElement.closest(".predictive-search-results__card--product");

    if (resourceCard) {
      handleResourceCardColorSwatchChange(variantId, resourceCard);
    }

    if (!card && !resourceCard) {
      console.log("Error: Product card not found for product ID:", productId);
      return;
    }

    // Update product link URLs with variant parameter
    // Use card if available, otherwise use resourceCard
    const cardElement = card;
    if (!cardElement) return;

    const productCardLink = cardElement.querySelector("a.product-card__link");
    const cardGalleryLink = cardElement.querySelector(".card-gallery a");
    const productTitleLink = cardElement.querySelector("a.product-card-gallery__title-placeholder");

    // Get base URL from any existing link
    const baseLink = productCardLink || cardGalleryLink;
    if (baseLink && baseLink.href) {
      // Remove existing variant parameter if present, then add new one
      const url = new URL(baseLink.href, window.location.origin);
      url.searchParams.set("variant", variantId);
      const newUrl = url.pathname + url.search;

      // Update all product links
      if (productCardLink) {
        productCardLink.href = newUrl;
      }
      if (cardGalleryLink) {
        cardGalleryLink.href = newUrl;
      }
      if (productTitleLink) {
        productTitleLink.href = newUrl;
      }
    }

    // Update size availability based on selected color
    if (colorValue && cardElement) {
      const sizeWrapper = cardElement.querySelector(".card__size[data-all-variants-map]");
      if (sizeWrapper) {
        const allVariantsMap = sizeWrapper.getAttribute("data-all-variants-map");
        if (allVariantsMap) {
          // Parse the variant map: "color:size:variant_id:available:url,color:size:variant_id:available:url"
          const variants = allVariantsMap.split(",").filter((entry) => entry.trim() !== "");

          // Filter variants for the selected color
          const colorVariants = variants
            .map((entry) => {
              const parts = entry.split(":");
              if (parts.length >= 5) {
                return {
                  color: parts[0],
                  size: parts[1],
                  variantId: parts[2],
                  available: parts[3] === "true",
                  url: parts.slice(4).join(":"), // URL might contain colons
                };
              }
              return null;
            })
            .filter((v) => v && v.color === colorValue);

          // Update each size element (they're nested inside card__size-wrapper)
          const sizeElements = sizeWrapper.querySelectorAll("[size-data-value]");
          sizeElements.forEach((sizeElement) => {
            const sizeValue = sizeElement.getAttribute("size-data-value");
            const matchingVariant = colorVariants.find((v) => v.size.trim() === sizeValue);

            if (matchingVariant) {
              // Update data attributes
              sizeElement.setAttribute("data-variant-id", matchingVariant.variantId);
              sizeElement.setAttribute("data-variant-available", matchingVariant.available.toString());
              sizeElement.setAttribute("data-variant-url", matchingVariant.url);
              sizeElement.setAttribute("data-color", colorValue);

              // Update availability class
              if (matchingVariant.available) {
                sizeElement.classList.remove("out-of-stockTemp");
              } else {
                sizeElement.classList.add("out-of-stockTemp");
              }

              // Update link URL
              const sizeLink = sizeElement.querySelector("a");
              if (sizeLink) {
                sizeLink.href = matchingVariant.url;
              }
            }
          });

          // Update the selected color on the wrapper
          sizeWrapper.setAttribute("data-selected-color", colorValue);
        }
      }
    }

    // Update slideshow to show the variant's slide (each color = its own slide)
    const mediaId = swatchElement.getAttribute("data-media-id");
    const productCardEl = card.closest("product-card") || card.querySelector("product-card");
    const slideshow = card.querySelector("slideshow-component");

    const hasVariantSlide = mediaId && slideshow && slideshow.querySelector(`slideshow-slide[slide-id="${mediaId}"]`);

    if (slideshow && !hasVariantSlide) {
      // The card only renders some of the product's media, so the selected color's slide may not
      // exist. Fall back to swapping the image of the first slide in place.
      const slide = slideshow.querySelector("slideshow-slide");
      const img = slide?.querySelector("img");
      if (img) {
        const src = variantImageUrl.replace(/([?&])width=\d+/, "$1width=1200");
        slideshow.querySelectorAll("slideshow-slide").forEach((el) => {
          if (el.hasAttribute("variant-image")) el.hidden = el !== slide;
        });
        if (img.dataset.originalSrc == null) {
          img.dataset.originalSrc = img.getAttribute("src") || "";
          img.dataset.originalSrcset = img.getAttribute("srcset") || "";
        }
        img.removeAttribute("srcset");
        img.src = src;
        slideshow.select(0, undefined, { animate: false });
      }
    }

    if (hasVariantSlide) {
      // Undo any in-place image swap from a previous fallback so the original slides show again
      slideshow.querySelectorAll("img[data-original-src]").forEach((img) => {
        img.src = img.dataset.originalSrc;
        if (img.dataset.originalSrcset) img.setAttribute("srcset", img.dataset.originalSrcset);
        delete img.dataset.originalSrc;
        delete img.dataset.originalSrcset;
      });
      // Unhide the selected variant's slide, hide others (like product-card's #updateVariantImages)
      const slides = Array.from(slideshow.querySelectorAll("slideshow-slide"));
      for (const slide of slides) {
        if (slide.getAttribute("variant-image") != null) {
          slide.hidden = slide.getAttribute("slide-id") !== mediaId;
        }
      }
      slideshow.select({ id: mediaId }, undefined, { animate: false });

      // Restore to first slide when mouse leaves card
      const targetCard = productCardEl || card;
      if (!targetCard.__colorSwatchRestoreAttached) {
        targetCard.__colorSwatchRestoreAttached = true;
        const debouncedRestore = debounce(function restoreSlideshow() {
          // Reset variant slide visibility: first variant visible, rest hidden
          const variantSlides = Array.from(slideshow.querySelectorAll("slideshow-slide[variant-image]"));
          const firstVariantId = variantSlides[0]?.getAttribute("slide-id");
          if (firstVariantId) {
            for (const slide of variantSlides) {
              slide.hidden = slide.getAttribute("slide-id") !== firstVariantId;
            }
          }
          slideshow.select(0, undefined, { animate: false });
          targetCard.__colorSwatchRestoreAttached = false;
          targetCard.removeEventListener("mouseleave", debouncedRestore);
        }, 150);
        targetCard.addEventListener("mouseleave", debouncedRestore, { once: true });
      }
    }
  } catch (error) {
    console.log("Error at colorSwatchsChange:", error);
  }
}

function handleResourceCardColorSwatchChange(variantId, parentElm) {
  const productCardLink = parentElm.querySelector(".resource-card__link");
  if (productCardLink) {
    const url = new URL(productCardLink.href, window.location.origin);
    url.searchParams.set("variant", variantId);
    productCardLink.href = url.pathname + url.search;
    window.location.href = productCardLink.href;
  }
}

function hideHoverImageWhenSlideButtonIsClicked() {
  document.addEventListener("click", function (event) {
    // Only act if a slide button is clicked
    const productCard = event.target.closest(".product-card");
    let isSliderButtons = false;
    if (event.target && event.target.closest(".slideshow-control")) {
      isSliderButtons = true;
    }
    if (!isSliderButtons) {
      return;
    }
    if (productCard) {
      // Find the nearest product-card wrapper of the clicked button and add class 'slider-click'
      if (productCard) {
        productCard.classList.add("slider-click");

        // Use debounce to ensure only one removal is queued at a time
        if (!productCard.__removeSliderClickDebounced) {
          productCard.__removeSliderClickDebounced = debounce(() => {
            productCard.classList.remove("slider-click");
            productCard.__removeSliderClickDebounced = null;
          }, 3000);
        }

        const mouseLeaveHandler = () => {
          productCard.__removeSliderClickDebounced();
          productCard.removeEventListener("mouseleave", mouseLeaveHandler);
        };

        productCard.addEventListener("mouseleave", mouseLeaveHandler, { once: true });
      }
    } else if (event.target.closest(".resource-card")) {
      const resourceCard = event.target.closest(".resource-card");
      console.log("resourceCard", resourceCard);
    }
  });
}

function debounce(func, wait) {
  let timeout;
  return function (...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}

document.addEventListener("DOMContentLoaded", function () {
  hideHoverImageWhenSlideButtonIsClicked();
});
